import { Tag } from "antd";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";
import { useSelector } from "react-redux";

const RegularInfo = ({ data }) => {
  const inf = useSelector((state) => state.users.user);

  const renderInterval = (type, value) => {
    if (type === "hours") {
      const days = Math.floor(value / 24);
      const hours = value % 24;
      return hours > 0
        ? `Every ${days} Days and ${hours} Hours`
        : `Every ${days} Days`;
    } else if (type === "odometer") {
      return `Every ${Math.round(value)} ${inf?.attributes?.distanceUnit}`;
    }
    return value;
  };
  const getTagColor = (priority) => {
    const colorMap = {
      Highest: "red",
      High: "volcano",
      Medium: "orange",
      Low: "green",
    };
    return colorMap[priority] || "default";
  };
  return (
    <div>
      <div>
        <div className="display-border">
          <PopupBodyItem
            title="Maintenance Name"
            item={data?.name || "volvo75600-2152"}
          />
          <PopupBodyItem title="Code" item={data?.code || "#demo/RM-4"} />
          <PopupBodyItem title="Priority">
            <Tag color={getTagColor(data?.priority)}>
              {data?.priority || "Highest"}
            </Tag>
          </PopupBodyItem>
          <PopupBodyItem
            title="Maintenance Intervals"
            item={Math.round(data.start)}
          />

          <PopupBodyItem
            title="Maintenance Intervals"
            item={
              renderInterval(data.type, data.period) ||
              "Every 1000 KM or 1 Month"
            }
          />

          {/* <PopupBodyItem
            title="Maintenance Reminder"
            item={data?.name || "9000 KM or 25 Days"}
          /> */}
          <PopupBodyItem
            title="Description"
            item={data?.description || "------"}
          />
        </div>
      </div>
    </div>
  );
};

export default RegularInfo;
